import { render, staticRenderFns } from "./Ebook.vue?vue&type=template&id=b5bae732&scoped=true"
import script from "./Ebook.vue?vue&type=script&lang=js"
export * from "./Ebook.vue?vue&type=script&lang=js"
import style0 from "./Ebook.vue?vue&type=style&index=0&id=b5bae732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bae732",
  null
  
)

export default component.exports